import { render, staticRenderFns } from "./ListMessage.vue?vue&type=template&id=064d9224&"
import script from "./ListMessage.vue?vue&type=script&lang=js&"
export * from "./ListMessage.vue?vue&type=script&lang=js&"
import style0 from "./ListMessage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports